"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _dsIcons = require("@olxbr/ds-icons");
var _ChatImageLoading = require("../ChatImageLoading");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var AdImage = exports.AdImage = function AdImage(_ref) {
  var adStatus = _ref.adStatus,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? '' : _ref$image,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    imageSize = _ref.imageSize;
  var hasImage = !!image;
  var uriImage = getImageUrl(image, imageSize);
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatImageLoading.ChatImageLoading, {
      imageSize: imageSize
    });
  }
  if (!hasImage) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.PlaceholderWrapper, {
      imageSize: imageSize,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.Image, {
        color: "var(--color-neutral-110)",
        size: '28'
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("picture", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
      srcSet: uriImage.webp,
      type: "image/webp"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("source", {
      srcSet: uriImage.jpg,
      type: "image/jpeg"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Image, {
      src: uriImage.jpg,
      adStatus: adStatus,
      imageSize: imageSize,
      width: imageSize === 'large' ? '72px' : '44px',
      height: imageSize === 'large' ? '72px' : '44px',
      alt: "Imagem do produto"
    })]
  });
};
AdImage.propTypes = {
  image: _propTypes.string,
  isLoading: _propTypes.bool,
  imageSize: (0, _propTypes.oneOf)(['large', 'small'])
};
var getImageUrl = function getImageUrl(image, size) {
  if (image.includes('http')) return {
    webp: image,
    jpg: image
  };
  var _process$env$REACT_AP = "https://img.olx.com.br",
    REACT_APP_IMAGES_SERVER = _process$env$REACT_AP === void 0 ? 'https://img.olx.com.br' : _process$env$REACT_AP;
  var dimensions = size === 'large' ? '120x120' : '90x90';
  var imagePath = "/thumbs".concat(dimensions, "/").concat(image.substr(0, 2), "/").concat(image);
  return image ? {
    webp: "".concat(REACT_APP_IMAGES_SERVER).concat(imagePath.replace(/\.jpg$/, '.webp')),
    jpg: "".concat(REACT_APP_IMAGES_SERVER).concat(imagePath)
  } : {};
};